import bcryptjs from 'bcryptjs';
import db from './db';
import type { User } from './types';

let currentUser: User | null = null;

export async function login(email: string, password: string) {
  const user = await db.users.where('email').equals(email).first();
  
  if (!user || !user.password) {
    throw new Error('Invalid credentials');
  }

  const validPassword = await bcryptjs.compare(password, user.password);
  if (!validPassword) {
    throw new Error('Invalid credentials');
  }

  // Store the current user
  currentUser = user;

  // Don't send password back to client
  const { password: _, ...userWithoutPassword } = user;
  return userWithoutPassword;
}

export async function getCurrentUser() {
  if (currentUser) {
    const { password: _, ...userWithoutPassword } = currentUser;
    return userWithoutPassword;
  }
  return null;
}

export async function logout() {
  currentUser = null;
}